export default __webpack_public_path__ + "static/course-logo-ser-8042e45c9f1e0890f6e8ebba49d58742.jpg";